import { render, staticRenderFns } from "./StockOrderStatusSelect.vue?vue&type=template&id=aea4f998"
import script from "./StockOrderStatusSelect.vue?vue&type=script&lang=ts"
export * from "./StockOrderStatusSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports